/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/DialogScheduleBatch', 'model/DialogScheduleBatchReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/DialogScheduleBatch'), require('../model/DialogScheduleBatchReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.DialogScheduleBatchApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.DialogScheduleBatch, root.ForStractionServiceApi.DialogScheduleBatchReport);
  }
}(this, function(ApiClient, DialogScheduleBatch, DialogScheduleBatchReport) {
  'use strict';

  /**
   * DialogScheduleBatch service.
   * @module api/DialogScheduleBatchApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new DialogScheduleBatchApi. 
   * @alias module:api/DialogScheduleBatchApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the dialogScheduleBatchAddPut operation.
     * @callback module:api/DialogScheduleBatchApi~dialogScheduleBatchAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/DialogScheduleBatch} body 
     * @param {module:api/DialogScheduleBatchApi~dialogScheduleBatchAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.dialogScheduleBatchAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dialogScheduleBatchAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling dialogScheduleBatchAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/DialogScheduleBatch/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dialogScheduleBatchCreateBatchResultStrategyGet operation.
     * @callback module:api/DialogScheduleBatchApi~dialogScheduleBatchCreateBatchResultStrategyGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * createBatchResultStrategy
     * @param {String} _4SAPIAppID 
     * @param {Integer} batchID 
     * @param {module:api/DialogScheduleBatchApi~dialogScheduleBatchCreateBatchResultStrategyGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.dialogScheduleBatchCreateBatchResultStrategyGet = function(_4SAPIAppID, batchID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dialogScheduleBatchCreateBatchResultStrategyGet";
      }

      // verify the required parameter 'batchID' is set
      if (batchID == undefined || batchID == null) {
        throw "Missing the required parameter 'batchID' when calling dialogScheduleBatchCreateBatchResultStrategyGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'batchID': batchID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/DialogScheduleBatch/createBatchResultStrategy', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dialogScheduleBatchCreateBatchResultWorkshopGet operation.
     * @callback module:api/DialogScheduleBatchApi~dialogScheduleBatchCreateBatchResultWorkshopGetCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * createBatchResultWorkshop
     * @param {String} _4SAPIAppID 
     * @param {Integer} batchID 
     * @param {Boolean} closeBatch 
     * @param {module:api/DialogScheduleBatchApi~dialogScheduleBatchCreateBatchResultWorkshopGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.dialogScheduleBatchCreateBatchResultWorkshopGet = function(_4SAPIAppID, batchID, closeBatch, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dialogScheduleBatchCreateBatchResultWorkshopGet";
      }

      // verify the required parameter 'batchID' is set
      if (batchID == undefined || batchID == null) {
        throw "Missing the required parameter 'batchID' when calling dialogScheduleBatchCreateBatchResultWorkshopGet";
      }

      // verify the required parameter 'closeBatch' is set
      if (closeBatch == undefined || closeBatch == null) {
        throw "Missing the required parameter 'closeBatch' when calling dialogScheduleBatchCreateBatchResultWorkshopGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'batchID': batchID,
        'closeBatch': closeBatch
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/DialogScheduleBatch/createBatchResultWorkshop', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dialogScheduleBatchDeleteGet operation.
     * @callback module:api/DialogScheduleBatchApi~dialogScheduleBatchDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/DialogScheduleBatchApi~dialogScheduleBatchDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.dialogScheduleBatchDeleteGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dialogScheduleBatchDeleteGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling dialogScheduleBatchDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/DialogScheduleBatch/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dialogScheduleBatchEditPut operation.
     * @callback module:api/DialogScheduleBatchApi~dialogScheduleBatchEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/DialogScheduleBatch} body 
     * @param {module:api/DialogScheduleBatchApi~dialogScheduleBatchEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.dialogScheduleBatchEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dialogScheduleBatchEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling dialogScheduleBatchEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/DialogScheduleBatch/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dialogScheduleBatchLoadGet operation.
     * @callback module:api/DialogScheduleBatchApi~dialogScheduleBatchLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DialogScheduleBatchReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/DialogScheduleBatchApi~dialogScheduleBatchLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DialogScheduleBatchReport}
     */
    this.dialogScheduleBatchLoadGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dialogScheduleBatchLoadGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling dialogScheduleBatchLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = DialogScheduleBatchReport;

      return this.apiClient.callApi(
        '/DialogScheduleBatch/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dialogScheduleBatchSendBatchGet operation.
     * @callback module:api/DialogScheduleBatchApi~dialogScheduleBatchSendBatchGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * sendBatch
     * @param {String} _4SAPIAppID 
     * @param {Integer} batchID 
     * @param {module:api/DialogScheduleBatchApi~dialogScheduleBatchSendBatchGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.dialogScheduleBatchSendBatchGet = function(_4SAPIAppID, batchID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dialogScheduleBatchSendBatchGet";
      }

      // verify the required parameter 'batchID' is set
      if (batchID == undefined || batchID == null) {
        throw "Missing the required parameter 'batchID' when calling dialogScheduleBatchSendBatchGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'batchID': batchID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/DialogScheduleBatch/sendBatch', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dialogScheduleBatchSendBatchToTeamsGet operation.
     * @callback module:api/DialogScheduleBatchApi~dialogScheduleBatchSendBatchToTeamsGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * sendBatchToTeams
     * @param {String} _4SAPIAppID 
     * @param {Integer} batchID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.conversationID 
     * @param {module:api/DialogScheduleBatchApi~dialogScheduleBatchSendBatchToTeamsGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.dialogScheduleBatchSendBatchToTeamsGet = function(_4SAPIAppID, batchID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dialogScheduleBatchSendBatchToTeamsGet";
      }

      // verify the required parameter 'batchID' is set
      if (batchID == undefined || batchID == null) {
        throw "Missing the required parameter 'batchID' when calling dialogScheduleBatchSendBatchToTeamsGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'batchID': batchID,
        'conversationID': opts['conversationID']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/DialogScheduleBatch/sendBatchToTeams', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dialogScheduleBatchSendBatchToWhatsAppGet operation.
     * @callback module:api/DialogScheduleBatchApi~dialogScheduleBatchSendBatchToWhatsAppGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * sendBatchToWhatsApp
     * @param {String} _4SAPIAppID 
     * @param {Integer} batchID 
     * @param {String} userNumberIdentifier 
     * @param {module:api/DialogScheduleBatchApi~dialogScheduleBatchSendBatchToWhatsAppGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.dialogScheduleBatchSendBatchToWhatsAppGet = function(_4SAPIAppID, batchID, userNumberIdentifier, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dialogScheduleBatchSendBatchToWhatsAppGet";
      }

      // verify the required parameter 'batchID' is set
      if (batchID == undefined || batchID == null) {
        throw "Missing the required parameter 'batchID' when calling dialogScheduleBatchSendBatchToWhatsAppGet";
      }

      // verify the required parameter 'userNumberIdentifier' is set
      if (userNumberIdentifier == undefined || userNumberIdentifier == null) {
        throw "Missing the required parameter 'userNumberIdentifier' when calling dialogScheduleBatchSendBatchToWhatsAppGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'batchID': batchID,
        'userNumberIdentifier': userNumberIdentifier
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/DialogScheduleBatch/sendBatchToWhatsApp', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
